export default class Video {
	static init(){
		document.addEventListener('bless', () => {
			const videoWrappers = document.querySelectorAll('[data-modal]');
			videoWrappers.forEach(videoWrapper => {
				new Video(videoWrapper);
			});
		});
	}

	constructor(videoWrapper){

		const openVideoModal = document.querySelectorAll('.js_play-button');
		const modalOuter = document.querySelector('.modal-outer');
		const modalInner = document.querySelector('.modal-inner');
		const tag = document.createElement('script');

		tag.src = "https://www.youtube.com/iframe_api";

		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		const el = document.body.querySelector("iframe");

		function enableScrollLock() {
			const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
			const body = document.body;
			body.style.position = 'fixed';
			body.style.top = `-${scrollY}`;
		}

		function disableScrollLock() {
			const body = document.body;
			const scrollY = body.style.top;
			body.style.position = '';
			body.style.top = '';
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
		}

		function handleButtonClick() {
			modalOuter.classList.add('open');
			enableScrollLock();
		}

		function closeModal() {
			disableScrollLock();
			modalOuter.classList.remove('open');
		}

		window.addEventListener('scroll', () => {
			document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
		});

		window.onYouTubeIframeAPIReady = function () {
			let player = new YT.Player( el, {
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});
		}

		function onPlayerReady(event) {

			openVideoModal.forEach(button =>
				button.addEventListener('click', function(e) {
					handleButtonClick();
					event.target.playVideo();
					modalOuter.classList.add('open');
				})
			);

			modalOuter.addEventListener('click', function(e) {
				const isOutside = !e.target.closest('.modal-inner');
				if (isOutside) {
					event.target.stopVideo();
					closeModal();
				}
			});

			window.addEventListener('keydown', e => {
				if (e.key === 'Escape') {
					event.target.stopVideo();
					closeModal();
				}
			});
		}

		function onPlayerStateChange(event) {

			if ((event.data === 1 ) || (event.data === -1 ) || (event.data === 3 ))  {
				modalInner.classList.add('js_video-playing');
				document.body.classList.add('modal-active');
		   	} else {
				closeModal();
			}
		}
	}
}
